export const FETCH_DASH_GRAPH_START = 'FETCH_DASH_GRAPH_START';
export const FETCH_DASH_GRAPH_SUCCESS = 'FETCH_DASH_GRAPH_SUCCESS';
export const FETCH_DASH_GRAPH_FAILURE = 'FETCH_DASH_GRAPH_FAILURE';

export const FETCH_DASH_TOP_START = 'FETCH_DASH_TOP_START';
export const FETCH_DASH_TOP_SUCCESS = 'FETCH_DASH_TOP_SUCCESS';
export const FETCH_DASH_TOP_FAILURE = 'FETCH_DASH_TOP_FAILURE';

export const FETCH_DASH_STATS_START = 'FETCH_DASH_STATS_START';
export const FETCH_DASH_STATS_SUCCESS = 'FETCH_DASH_STATS_SUCCESS';
export const FETCH_DASH_STATS_FAILURE = 'FETCH_DASH_STATS_FAILURE';

export const FETCH_DAILY_STATS_START = 'FETCH_DAILY_STATS_START';
export const FETCH_DAILY_STATS_SUCCESS = 'FETCH_DAILY_STATS_SUCCESS';
export const FETCH_DAILY_STATS_FAILURE = 'FETCH_DAILY_STATS_FAILURE';

export const FETCH_HOURLY_STATS_START = 'FETCH_HOURLY_STATS_START';
export const FETCH_HOURLY_STATS_SUCCESS = 'FETCH_HOURLY_STATS_SUCCESS';
export const FETCH_HOURLY_STATS_FAILURE = 'FETCH_HOURLY_STATS_FAILURE';

export const FETCH_SUB_STATS_START = 'FETCH_SUB_STATS_START';
export const FETCH_SUB_STATS_SUCCESS = 'FETCH_SUB_STATS_SUCCESS';
export const FETCH_SUB_STATS_FAILURE = 'FETCH_SUB_STATS_FAILURE';

export const FETCH_REFERRER_STATS_START = 'FETCH_REFERRER_STATS_START';
export const FETCH_REFERRER_STATS_SUCCESS = 'FETCH_REFERRER_STATS_SUCCESS';
export const FETCH_REFERRER_STATS_FAILURE = 'FETCH_REFERRER_STATS_FAILURE';

export const FETCH_GEO_STATS_START = 'FETCH_GEO_STATS_START';
export const FETCH_GEO_STATS_SUCCESS = 'FETCH_GEO_STATS_SUCCESS';
export const FETCH_GEO_STATS_FAILURE = 'FETCH_GEO_STATS_FAILURE';

export const FETCH_CLICK_STATS_START = 'FETCH_CLICK_STATS_START';
export const FETCH_CLICK_STATS_SUCCESS = 'FETCH_CLICK_STATS_SUCCESS';
export const FETCH_CLICK_STATS_FAILURE = 'FETCH_CLICK_STATS_FAILURE';

export const FETCH_SAFF_LIST_START = 'FETCH_SAFF_LIST_START';
export const FETCH_SAFF_LIST_SUCCESS = 'FETCH_SAFF_LIST_SUCCESS';
export const FETCH_SAFF_LIST_FAILURE = 'FETCH_SAFF_LIST_FAILURE';
